// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#canteen-menu {\n  height: 100%;\n}\n#canteen-menu .action-table {\n  margin-top: 8px;\n}", ""]);
// Exports
module.exports = exports;
